// In-memory demo data for MTSRpay when Supabase backend is unconfigured or offline

export const MOCK_SCHOOL = {
  id: 'sch-1',
  nama: 'Sekolah Menengah Agama MTSR',
  kod: 'MTSR',
  alamat: 'Jalan Masjid 12, 43000 Kajang, Selangor',
  telefon: '03-8888 1234',
  no_akaun_bank: 'Maybank 5621 0099 8877',
};

export const MOCK_SCHOOL_YEAR = {
  id: 'sy-1',
  school_id: 'sch-1',
  tahun: 2026,
  aktif: true,
};

export const MOCK_CLASSES = [
  { id: 'cls-1', school_id: 'sch-1', nama: 'Tahun 1 Bukhari', school_year_id: 'sy-1', wali_kelas_id: 'usr-guru-1' },
  { id: 'cls-2', school_id: 'sch-1', nama: 'Tahun 2 Muslim', school_year_id: 'sy-1', wali_kelas_id: 'usr-guru-2' },
  { id: 'cls-3', school_id: 'sch-1', nama: 'Tahun 3 Tirmizi', school_year_id: 'sy-1', wali_kelas_id: null },
];

export const MOCK_TARIFFS = [
  { id: 'trf-1', school_id: 'sch-1', nama: 'Yuran Bulanan', jumlah_rm: 80, jenis: 'bulanan', layak_diskon_sibling: true, school_year_id: 'sy-1' },
  { id: 'trf-2', school_id: 'sch-1', nama: 'Yuran Pendaftaran Tahunan', jumlah_rm: 150, jenis: 'tahunan', layak_diskon_sibling: false, school_year_id: 'sy-1' },
];

export const MOCK_DISCOUNT_RULES = [
  { id: 'dsc-1', school_id: 'sch-1', nama: 'Diskaun Adik-Beradik', jenis: 'peratus', nilai: 25, anak_ke_min: 2, aktif: true },
];

export const MOCK_PROFILES = [
  {
    id: 'usr-bendahara',
    school_id: 'sch-1',
    role: 'bendahara',
    nama: 'Ustaz Bendahara MTSR',
    email: 'bendaharamtsr@gmail.com',
    telefon: '012-3456789',
    aktif: true,
  },
  {
    id: 'usr-guru-1',
    school_id: 'sch-1',
    role: 'guru',
    nama: 'Cikgu Fatimah',
    email: 'guru.bukhari@mtsr.edu.my',
    telefon: '013-1112222',
    aktif: true,
  },
  {
    id: 'usr-guru-2',
    school_id: 'sch-1',
    role: 'guru',
    nama: 'Cikgu Zulkifli',
    email: 'guru.muslim@mtsr.edu.my',
    telefon: '013-3334444',
    aktif: true,
  },
  {
    id: 'usr-parent-1',
    school_id: 'sch-1',
    role: 'orangtua',
    nama: 'Puan Rahmah',
    email: 'keluarga.rahman@gmail.com',
    telefon: '011-2223333',
    aktif: true,
  },
  {
    id: 'usr-parent-2',
    school_id: 'sch-1',
    role: 'orangtua',
    nama: 'Puan Aisyah',
    email: 'ibu.aisyah@gmail.com',
    telefon: '019-8887777',
    aktif: true,
  },
];

const STUDENT_NAMES = [
  'Ahmad Firdaus bin Rahman',
  'Nur Aisyah binti Rahman',
  'Umar Hakim bin Rahman',
  'Muhammad Danish bin Abdullah',
  'Siti Khadijah binti Ismail',
  'Aiman Haikal bin Hassan',
  'Nurul Iman binti Zainal',
  'Yusuf Iskandar bin Osman',
  'Hana Sofea binti Karim',
  'Harith Danial bin Salleh',
  'Balqis Humaira binti Ibrahim',
  'Adam Mikail bin Yaakob',
];

export const MOCK_STUDENTS = STUDENT_NAMES.map((name, i) => {
  const clsId = `cls-${(i % 3) + 1}`;
  const pad = String(i + 1).padStart(3, '0');
  return {
    id: `st-${i + 1}`,
    school_id: 'sch-1',
    nama: name,
    no_pelajar: `MTSR26${pad}`,
    no_kp: `12010114${1000 + i}`,
    class_id: clsId,
    school_year_id: 'sy-1',
    telefon_orangtua: `012-34567${pad.slice(1)}`,
    aktif: true,
    created_at: '2026-01-01T00:00:00Z',
  };
});

export const MOCK_TEACHER_LINKS = [
  { school_id: 'sch-1', profile_id: 'usr-guru-1', class_id: 'cls-1', status: 'lulus' },
  { school_id: 'sch-1', profile_id: 'usr-guru-2', class_id: 'cls-2', status: 'lulus' },
];

export const MOCK_GROUPS = [
  { id: 'grp-1', school_id: 'sch-1', class_id: 'cls-1', nama: 'Kumpulan A', hoca_id: 'usr-guru-1' },
];

export const MOCK_PARENT_LINKS = [
  { school_id: 'sch-1', parent_profile_id: 'usr-parent-1', student_id: 'st-1', status: 'lulus', verified_by: 'usr-bendahara' },
  { school_id: 'sch-1', parent_profile_id: 'usr-parent-1', student_id: 'st-2', status: 'lulus', verified_by: 'usr-bendahara' },
  { school_id: 'sch-1', parent_profile_id: 'usr-parent-1', student_id: 'st-3', status: 'lulus', verified_by: 'usr-bendahara' },
  { school_id: 'sch-1', parent_profile_id: 'usr-parent-2', student_id: 'st-4', status: 'lulus', verified_by: 'usr-bendahara' },
];

export const MOCK_INVOICES = [
  // Rahman children (st-1, st-2, st-3)
  {
    id: 'inv-1',
    school_id: 'sch-1',
    student_id: 'st-1',
    tariff_id: 'trf-1',
    jumlah_rm: 80,
    diskon_rm: 0,
    diskon_nota: null,
    jumlah_bayar_rm: 80,
    status: 'lunas',
    due_date: '2026-06-30',
    periode: '2026-01',
    school_year_id: 'sy-1',
  },
  {
    id: 'inv-2',
    school_id: 'sch-1',
    student_id: 'st-2',
    tariff_id: 'trf-1',
    jumlah_rm: 80,
    diskon_rm: 20,
    diskon_nota: 'Diskaun adik-beradik 25%',
    jumlah_bayar_rm: 60,
    status: 'lunas',
    due_date: '2026-06-30',
    periode: '2026-01',
    school_year_id: 'sy-1',
  },
  {
    id: 'inv-3',
    school_id: 'sch-1',
    student_id: 'st-3',
    tariff_id: 'trf-1',
    jumlah_rm: 80,
    diskon_rm: 20,
    diskon_nota: 'Diskaun adik-beradik 25%',
    jumlah_bayar_rm: 60,
    status: 'belum',
    due_date: '2026-06-30',
    periode: '2026-02',
    school_year_id: 'sy-1',
  },
  {
    id: 'inv-4',
    school_id: 'sch-1',
    student_id: 'st-4',
    tariff_id: 'trf-1',
    jumlah_rm: 80,
    diskon_rm: 0,
    diskon_nota: null,
    jumlah_bayar_rm: 40,
    status: 'separa',
    due_date: '2026-06-30',
    periode: '2026-01',
    school_year_id: 'sy-1',
  },
  {
    id: 'inv-5',
    school_id: 'sch-1',
    student_id: 'st-5',
    tariff_id: 'trf-1',
    jumlah_rm: 80,
    diskon_rm: 0,
    diskon_nota: null,
    jumlah_bayar_rm: 0,
    status: 'belum',
    due_date: '2026-06-30',
    periode: '2026-01',
    school_year_id: 'sy-1',
  },
];

export const MOCK_PAYMENTS = [
  {
    id: 'pay-1',
    school_id: 'sch-1',
    invoice_id: 'inv-1',
    student_id: 'st-1',
    jumlah_rm: 80,
    kaedah: 'transfer',
    dicatat_oleh: 'usr-bendahara',
    nota: 'Bayaran yuran Januari',
    tanggal: '2026-01-15T10:00:00Z',
    voided: false,
  },
  {
    id: 'pay-2',
    school_id: 'sch-1',
    invoice_id: 'inv-2',
    student_id: 'st-2',
    jumlah_rm: 60,
    kaedah: 'transfer',
    dicatat_oleh: 'usr-bendahara',
    nota: 'Bayaran yuran Januari (diskaun)',
    tanggal: '2026-01-15T10:05:00Z',
    voided: false,
  },
  {
    id: 'pay-3',
    school_id: 'sch-1',
    invoice_id: 'inv-4',
    student_id: 'st-4',
    jumlah_rm: 40,
    kaedah: 'tunai',
    dicatat_oleh: 'usr-bendahara',
    nota: 'Bayaran separa',
    tanggal: '2026-01-20T14:30:00Z',
    voided: false,
  },
];

export const MOCK_RECEIPTS = [
  {
    id: 'rcp-1',
    school_id: 'sch-1',
    payment_id: 'pay-1',
    no_resit: 'R-2026-0001',
    tahun: 2026,
    drive_file_id: null,
    tanggal_cetak: '2026-01-15T10:02:00Z',
  },
  {
    id: 'rcp-2',
    school_id: 'sch-1',
    payment_id: 'pay-2',
    no_resit: 'R-2026-0002',
    tahun: 2026,
    drive_file_id: null,
    tanggal_cetak: '2026-01-15T10:06:00Z',
  },
];

export const MOCK_PAYMENT_PROOFS = [
  {
    id: 'prf-1',
    school_id: 'sch-1',
    student_id: 'st-3',
    invoice_id: 'inv-3',
    nama_file: 'resit_maybank_umar.png',
    status: 'pending',
    alasan_tolak: null,
    dibuka_bendahara_at: null,
    created_at: '2026-02-01T09:12:00Z',
  },
];

export const MOCK_PROOF_INVOICES = [
  { proof_id: 'prf-1', invoice_id: 'inv-3' },
];
